import { accessHours, officeHours } from "@/helpers/facility/access-office-hours-list";

const rentOnlineEnabled = 1;

export const currentFacility = {
  access_hours: accessHours,
  average_rating: null,
  banner_class: "",
  banner_text: "",
  bbb_seal: null,
  bre_group_id: null,
  city: null,
  contact_email: null,
  contact_email_cc: null,
  content_about: null,
  created_at: null,
  ctm_number_id: null,
  custom_css: null,
  custom_markup_body: null,
  custom_markup_head: null,
  directions_link: null,
  district: null,
  features: null,
  fees_admin: null,
  fees_late_amt: null,
  fees_late_pct: null,
  fees_lien: null,
  fees_lock_cut: null,
  fees_nsf: null,
  gmb_location_name: null,
  id: null,
  images: null,
  latitude: null,
  legal_name: null,
  location_code: null,
  longitude: null,
  markup_percent: null,
  max_unit_price: null,
  meta_description: null,
  meta_keywords: null,
  meta_title: null,
  min_unit_price: null,
  name: null,
  office_hours: officeHours,
  og_image: null,
  open_graph_photo_id: null,
  phone: null,
  pms: [],
  pms_enabled: null,
  postal_code: null,
  price_list: null,
  promotion_enabled: false,
  promotion_image: null,
  promotion_mobile_image: null,
  promotion_mobile_photo_url: null,
  promotion_photo_url: null,
  promotion_text: null,
  published: false,
  reservation_email: null,
  reservation_lead_max: null,
  reviews: null,
  reviews_enabled: null,
  ro_enabled: rentOnlineEnabled,
  ro_tpp_upsell_enabled: rentOnlineEnabled === 1 || rentOnlineEnabled === true ? 1 : 0,
  sitelink_units_last_polled: null,
  slug: null,
  social_links: null,
  state: null,
  street_address: null,
  time_zone: "",
  uhaul_enabled: false,
  uhaul_link: null,
  unit_additional_promo: "",
  unit_attribute_map: null,
  unit_type_sort_by: "price",
  updated_at: null,
  virtual_tour_link: ""
};
